import { expenseTypeDescriptions } from '@/helpers/const';

const unknownExpenseDescription: Record<string, string> = {
  shortFormTitle: 'Unknown expense',
  tooltip: 'Unknown expense type',
};

/**
 * Resolves an expense type to its display description.
 *
 * Falls back to an "unknown" description when the backend returns an expense
 * type we don't have local copy for (e.g. a newly added type), so the UI
 * degrades gracefully instead of throwing. Mirrors the CRM behaviour.
 */
export function getExpenseDescription(type: string | undefined | null): Record<string, string> {
  return expenseTypeDescriptions[type ?? ''] ?? unknownExpenseDescription;
}
